export default __webpack_public_path__ + "static/media/webfix-studio-logo-918x250.15ebb989.png";